import { render, staticRenderFns } from "./TaxRefundDialog.vue?vue&type=template&id=22866716&scoped=true"
import script from "./TaxRefundDialog.vue?vue&type=script&lang=ts"
export * from "./TaxRefundDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22866716",
  null
  
)

export default component.exports